/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Booking_EstesInputs */

const en_orders_booking_estes = /** @type {(inputs: Orders_Booking_EstesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking LTL...`)
};

const es_orders_booking_estes = /** @type {(inputs: Orders_Booking_EstesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservando LTL...`)
};

/**
* | output |
* | --- |
* | "Booking LTL..." |
*
* @param {Orders_Booking_EstesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_booking_estes = /** @type {((inputs?: Orders_Booking_EstesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Booking_EstesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_booking_estes(inputs)
	return es_orders_booking_estes(inputs)
});